import { LegacyUniversalSearch } from '@reapit-sales/navigation'
import {
  LegacyCRMIframeTriggerClickEvent,
  PanelLegacyLink,
  ReactToLegacyCrmPostMessageAction,
} from '@reapit-sales/legacy-crm'

import { trackMixpanelAction, NAVIGATION } from '@reapit-sales/utilities'

/**
 * `getUniversalSearchTrigger` returns a `LegacyUniversalSearch` object that triggers the legacy CRM's
 * universal search panel via a postMessage event.
 *
 * ### Props:
 * @param isLegacyCRMIframeLoaded - A boolean indicating whether the legacy CRM iframe is loaded and ready.
 * @param legacyCRMUrl - The URL of the legacy CRM iframe, used to send the postMessage.
 *
 * ### Returns:
 * A `LegacyUniversalSearch` object containing a `onClick` function.
 * When triggered, the onClick sends a `ReactToIframeMessageTriggerClickEvent` to the legacy CRM iframe,
 * targeting the universal search panel using the `UniversalSearchId` selector.
 *
 * ### Behavior:
 * 1. Wraps a postMessage trigger using `LegacyCRMIframeTriggerClickEvent`.
 * 2. Ensures message is only sent if the iframe is considered "loaded".
 */
export const getUniversalSearchTrigger = (
  isLegacyCRMIframeLoaded: boolean,
  legacyCRMUrl: string,
  legacyCRMIframePageName: string,
): LegacyUniversalSearch => ({
  onClick: () => {
    // Track the Mixpanel event for navigating to the Universal Search
    trackMixpanelAction(NAVIGATION.ACTION.NAVIGATE_UNIVERSAL_SEARCH, {
      Modal: NAVIGATION.MODAL_NAME.UNIVERSAL_SEARCH,
      FromRoute: legacyCRMIframePageName,
    })
    LegacyCRMIframeTriggerClickEvent({
      action: ReactToLegacyCrmPostMessageAction.ReactToIframeMessageTriggerClickEvent,
      iframeLoaded: isLegacyCRMIframeLoaded,
      idSelector: PanelLegacyLink.UniversalSearchId,
      legacyCRMUrl: legacyCRMUrl,
    })
  },
})
